<template>
  <v-container fluid>
    <h2 class="mb-5">お知らせ</h2>
    <div style="max-width: 700px;" class="mt-7 mx-auto">
      <v-row>
        <v-col cols="12" class="my-7 text-center" v-if="isLoadingAnnouncements">
          <v-progress-circular indeterminate color="grey-darken-3"></v-progress-circular>
        </v-col>

        <v-col cols="12" v-for="announcement in announcements" v-bind:key="(announcement.timestamp + announcement.title)">
          <v-card>
            <v-card-item>
              <v-card-title class="ma-1 text-pre-wrap">
                {{ announcement.title }}
              </v-card-title>
              <v-card-subtitle class="mt-2 text-end text-subtitle-2">
                {{ announcement.timestamp }}
              </v-card-subtitle>
            </v-card-item>
            <v-card-text class="pb-5">
              <v-divider class="mb-5"></v-divider>

              <div class="px-1 text-subtitle-1 announcement-body" v-html="announcement.body"></div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>

import { ref, onMounted } from 'vue';

import axios from 'axios';

import config from '@/config.js';

export default {
  name: 'AnnounceView',
  setup() {

    const isLoadingAnnouncements = ref(true);
    const announcements = ref([]);

    onMounted(() => {

      axios.get(
        config.API_URL +
        `/announcements`,
        { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem("access-token") } }
      ).then((response) => {

        isLoadingAnnouncements.value = false;
        announcements.value = response.data.announcements;

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });

    });

    return {
      isLoadingAnnouncements,
      announcements
    }

  }
}

</script>

<style scoped>

  .announcement-body :link {
    color: #1976D2; /* blue-darken-2 */
  }

  .announcement-body :visited {
    color: #1976D2; /* blue-darken-2 */
  }

</style>
